export const isEmpty = val => {
	return val === '' || val === null || val === undefined || isEmptyArray(val);
};

export const isEmptyArray = val => {
	return Array.isArray(val) && val.length === 0;
};

export const isRequired = text => val => isEmpty(val) ? text : undefined;



// WEBPACK FOOTER //
// ./src/common/validators/index.js